module.exports = __webpack_public_path__ + "media/images/subject_img/ARCHITECTURE-826cf803c7cdb982cf0d6e9a2863b226.jpg";